import React, { Component } from 'react'
import * as actions from "../actions";

import MentionEditor from "../../common/components/mention-editor";
import SimpleModal from "../../common/components/simple-modal";

const EditCommentLink = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return this.state.isModalOpen || nextState.isModalOpen;
  },
  getInitialState: function () {
    return {
      isModalOpen: false
    };
  },
  render() {
    const title = "Edit Comment";
    return (
      <a href="#" onClick={this.openModal}>
        {title}
        <SimpleModal
          isOpen={this.state.isModalOpen}
          onCloseClick={this.closeModal}
          modalId="edit-post"
          modalClassName="edit-feed-post-modal"
          centered={true}
        >
          <h1>{title}</h1>
          <form onSubmit={this.handleFormSubmit}>
            <MentionEditor
              onSubmit={this.handleFormSubmit}
              publicRef={(c) => this.mentionEditor = c}
              initialContent={this.props.comment || ''}
              initialMentions={this.props.mentions || []}
              autoFocus={true}
            />
            <button type="button" onClick={this.closeModal} className="button-primary-inverse">
              Cancel
            </button>
            <button type="submit" className="button-primary">
              Update
            </button>
          </form>
        </SimpleModal>
      </a>
    );
  },
  handleFormSubmit(e) {
    e.preventDefault();

    evite.requestIdleCallback(() => {
      const { comment, mentions } = this.mentionEditor;

      const { postId, postType } = this.props;

      // Don't allow empty comments if post has no content:
      // https://evitetracking.atlassian.net/browse/EVT-7672
      if (postType === "comments" && comment.trim().length === 0) {
        return false;
      }

      actions.editFeedComment(postId, comment, mentions);
      this.closeModal();
    });
  },
  openModal(e) {
    e.preventDefault();
    this.setState({ isModalOpen: true });
  },
  closeModal() {
    this.setState({ isModalOpen: false });
  }
});

export default EditCommentLink;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/edit-comment-link.es6